<app-generic-label class="context-label" [label]="label">

    <!-- title -->
    <div class="html" #title [innerHTML]="label.title | markdown" label-header>
    </div>

    <!-- node actions -->
    <div *ngIf="node" class="context-label__actions" label-actions>
      <ng-content></ng-content>
      <app-node-actions
        *ngIf="enableActions"
        eventCategory="Context Node"
        [node]="node"
        theme="light">
      </app-node-actions>
    </div>

    <ng-container *ngIf="enableInfo" label-more>
      <a
        @show
        *ngIf="node && node.description"
        class="context-label__more"
        (click)="handleReadMoreClick()">Read More...</a>
    </ng-container>

</app-generic-label>